module.exports = __webpack_public_path__ + "img/image_Placeholder.0d6e064b.png";